/**
 * C端主布局组件
 */
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

export default function Layout() {
  const location = useLocation()

  // 验真页面隐藏Header和Footer
  const hideChrome = location.pathname.startsWith('/verify')

  if (hideChrome) {
    return <Outlet />
  }

  return (
    <div className="min-h-screen bg-cyber-dark flex flex-col">
      <Header />
      <main className="flex-1 pt-16 pb-8 pb-safe">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
